import React, { useEffect, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { getName } from '../services';

const Banner = () => {
  const [name, setName] = useState('');
  useEffect(() => {
    const [rta, abortController] = getName();
    rta.then((n) => setName(n));
    return () => {
      abortController.abort();
    };
  }, []);
  return (
    <Flex bgColor="gray.100" justify="center" p="4">
      <Text>
        You are connecting to
        {' '}
        <Text as="span" fontStyle="italic" fontWeight="bold">{name}</Text>
      </Text>
    </Flex>
  );
};

export default Banner;
